import useSWR from 'swr';
import { useTranslation } from 'react-i18next';

import { getConfig } from 'configs';
import { LOCALES } from 'configs/getConfig';
import { fetcher } from 'utils';

interface ChequeInfo {
  bankAccountNumber: string;
  bankAddress: string;
  bankCode: string;
  beneficiaryBankName: string;
  beneficiaryName: string;
  branchCode: string;
  swiftCode: string;
  directMailTo: string;
}

export const useChequeInfo = () => {
  const { i18n } = useTranslation();
  const { cmsUrl } = getConfig();

  const locale = LOCALES.find((l) => l === i18n.language) ?? LOCALES[0];

  return useSWR<ChequeInfo>(cmsUrl.json.shortfall.chequeInfo[locale], fetcher);
};
